<div data-testid="available-places-info" class="flex items-start">
  <i class="g-filter-green-700 -mt-0.5 block h-6 w-6 shrink-0 bg-[url(../assets/icons/info-icon.svg)]"></i>
  <div class="grow px-2 text-sm font-normal">
    <h3 class="mb-1 text-base font-bold leading-normal">Important Information</h3>
    <p>
      Online service {{ isResidentialService() ? 'order' : 'request' }}s are only available in select areas. You can
      view the full list of
      <button
        aria-haspopup="dialog"
        [attr.aria-busy]="isCitiesDialogPending()"
        [disabled]="isCitiesDialogPending()"
        class="cursor-pointer font-medium underline focus:rounded-sm focus:outline focus:outline-2 focus:outline-offset-4 focus:outline-[#00263E]"
        (click)="openCitiesDialog()"
        data-testid="supported-cities-link"
      >
        supported cities
        @if (isCitiesDialogPending()) {
          <csl-icon name="loader-icon" class="size-4 animate-spin bg-blue-900 align-middle"></csl-icon>
        }</button
      >. To place an order, simply enter your address. If your location isn’t currently supported online, please give us
      a call at <b class="font-medium">{{ contactPhone | phone: 'XXX-XXX-XXXX' }}</b
      >, Mon–Fri 7 am – 5 pm, Sat 8 am – 12 pm.
    </p>
  </div>
</div>
